import React, { useEffect, useState } from 'react';

const FallingStars = () => {
  const [stars, setStars] = useState([]);

  useEffect(() => {
    // Generate a random set of stars
    const createStars = () => {
      const newStars = [];
      for (let i = 0; i < 200; i++) { // Increase number of stars to 200
        const size = Math.random() * 3 + 2; // Smaller stars to balance more stars
        const positionX = Math.random() * 100; // Random position across the X-axis
        const positionY = Math.random() * 20; // Spawn stars mostly near the top 20% of the viewport
        const delay = Math.random() * 0.5; // Shorter delay for faster spawn rate
        const duration = Math.random() * 4 + 3; // Faster fall duration between 3 and 7 seconds

        newStars.push({
          id: i,
          size,
          positionX,
          positionY, // Random Y-axis position (near the top)
          delay,
          duration,
        });
      }
      setStars(newStars);
    };

    createStars();
  }, []);

  return (
    <div className="absolute z-[-1] top-0 w-full h-screen bg-transparent overflow-hidden">
      {stars.map((star) => (
        <div
          key={star.id}
          className="absolute bg-dark dark:bg-white rounded-full"
          style={{
            width: `${star.size}px`,
            height: `${star.size}px`,
            left: `${star.positionX}%`,
            top: `${star.positionY}vh`, // Start mostly near the top of the Y-axis
            animation: `fall ${star.duration}s linear ${star.delay}s infinite`,
          }}
        />
      ))}
      {/* Tailwind CSS animation for the falling effect */}
      <style>{`
        @keyframes fall {
          0% {
            transform: translateY(0);
          }
          100% {
            transform: translateY(100vh);
          }
        }
      `}</style>
    </div>
  );
};

export default FallingStars;
